"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
exports.default = {
    blocks: {
        Flexbox: (0, vue_1.defineAsyncComponent)(function () {
            return Promise.resolve().then(function () { return __importStar(require('@distancify/storyblok-flexbox')); });
        }),
        Image: (0, vue_1.defineAsyncComponent)(function () {
            return Promise.resolve().then(function () { return __importStar(require('@distancify/storyblok-image')); });
        }),
        Html: (0, vue_1.defineAsyncComponent)(function () {
            return Promise.resolve().then(function () { return __importStar(require('@distancify/storyblok-html')); });
        }),
        Margin: (0, vue_1.defineAsyncComponent)(function () {
            return Promise.resolve().then(function () { return __importStar(require('@distancify/storyblok-margin')); });
        }),
        GlobalBlockContainer: (0, vue_1.defineAsyncComponent)(function () {
            return Promise.resolve().then(function () { return __importStar(require('@distancify/storyblok-global-block-container')); });
        }),
        StandardButton: (0, vue_1.defineAsyncComponent)(function () {
            return Promise.resolve().then(function () { return __importStar(require('@distancify/storyblok-button')); });
        }),
    },
    pages: {
        GlobalBlock: (0, vue_1.defineAsyncComponent)(function () {
            return Promise.resolve().then(function () { return __importStar(require('@distancify/storyblok-global-block')); });
        }),
    },
};
//# sourceMappingURL=index.js.map